module.exports = __webpack_public_path__ + "img/4.54b6c0b1.svg";